import React from 'react';

// material-ui
import { AppBar, Box, ButtonBase, Grid, Link,Toolbar, Typography } from '@mui/material';
import ExtranetLogo from '../../components/nav/ExtranetLogo';
import { useTheme } from '@mui/material/styles';

interface Props {
    applicationName: string;
    homepageLink?: string;
}

const TopBar = (props: Props): JSX.Element => {

    const theme = useTheme();

    return (
        <Grid item xs={12}>
            {/* top navigation bar */}
            <AppBar
                position="relative"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: '',
                    transition: 'none',
                }}
            >
                <Toolbar>
                    <Box
                        sx={{
                            width: 228,
                            display: 'flex',
                        }}
                    >
                        <Box component="span" sx={{ display: 'block', flexGrow: 1 }}>
                            <ButtonBase>
                                <ExtranetLogo></ExtranetLogo>
                            </ButtonBase>
                        </Box>
                    </Box>

                    <Box sx={{ flexGrow: 1 }} marginTop={3}>
                        <Typography variant="h6" sx={{ color: theme.palette.info.main }} fontWeight={550}>
                            {
                                props.homepageLink ?
                                    <Link href={props.homepageLink} underline="none">{props.applicationName}</Link>
                                    :
                                    <span>{props.applicationName}</span>
                            }
                            
                        </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 2 }} marginTop={3}>
                        <Typography variant="h6">
                            Today: {new Date().toLocaleDateString()}
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>
        </Grid>
    );
};

export default TopBar